import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-md glass rounded-3xl p-8 sm:p-10">
        <span className="eyebrow">License Holder</span>
        <h1 className="font-display tracking-tight text-3xl mt-4">Sign in to Fitest</h1>
        <p className="text-sm text-slate-400 mt-2">Access your audit links, leads and reports.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest text-slate-300">Email</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/5 border-white/10 mt-1 h-11"
              data-testid="login-email"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-widest text-slate-300">Password</Label>
            <Input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white/5 border-white/10 mt-1 h-11"
              data-testid="login-password"
            />
          </div>
          {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
          <Button type="submit" disabled={loading} className="btn-glow w-full rounded-full h-12" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="mt-6 text-sm text-slate-400 text-center">
          No account?{" "}
          <Link to="/register" className="text-brand hover:underline" data-testid="login-to-register">Create one</Link>
        </p>
      </div>
    </div>
  );
}
